export const REQUEST_PENDING = 'REQUEST_PENDING';
export const GET_VEHICLE_COUNT = 'GET_VEHICLE_COUNT';
export const REQUEST_ERROR = 'REQUEST_ERROR';
export const SET_LOADING = 'SET_LOADING';
